module.exports = __webpack_public_path__ + "img/banano-bet-logo-yh.b4dd859749ad7b95adc829d6082e04aa.svg";